import { ITmaOverride } from "@/store/slices/devTools/types"

export const resolveIsTMA = (
  override: ITmaOverride,
  hasTgUser: boolean
): boolean => (override === "auto" ? hasTgUser : override === "tma")
